import axios from '../wmsAxios'

/*
 * 主流程管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/rfMainProcessDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/rfMainProcessDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/rfMainProcessDetail/findPage',
        method: 'post',
        data
    })
}

// 获取主流程名称列表
export const getMainProcessNames = (params) => {
    return axios({
        url: '/rfMainProcessDetail/getMainProcessNames',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/rfMainProcessDetail.js